"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apolloBoost = require("apollo-boost");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation changePassword($password: String!) {\n        changePassword(password: $password) {\n            email\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var CHANGE_PASSWORD_QUERY = (0, _apolloBoost.gql)(_templateObject());

var _default = function _default() {
  return {
    mutation: CHANGE_PASSWORD_QUERY,
    module: 'users',
    buildVariables: function buildVariables(password) {
      return {
        password: password
      };
    }
  };
};

exports.default = _default;